import React from 'react';
import { includes } from 'lodash';

import DefaultsTable from './DefaultsTable';
import UsageTable from './UsageTable';

const DefaultsOverview = ({
  settings = []
}) => {
  const defaultSettings = []
  const groupSettings = []
  const groupSettingKeys = [
    'notification_group_post',
    'notification_group_join',
    'notification_group_request',
    'notification_group_message_tag_all'
  ]

  settings.map((setting, _) => {
    if(includes(groupSettingKeys, setting['title']))
      groupSettings.push(setting)
    else
      defaultSettings.push(setting)
  })

  return (
    <div className='DefaultsOverview'>
      <div>
        <UsageTable settings={defaultSettings} />
        <UsageTable settings={groupSettings} />
      </div>
      <div>
        <DefaultsTable settings={defaultSettings} />
        <DefaultsTable settings={groupSettings} title='Group User Default Settings' />
      </div>
    </div>
  )
}

export default DefaultsOverview;
